(function () {
    'use strict';

    // School search functionality
    function initSchoolSearch() {
        const searchInput = document.querySelector('#school-form .school-input-text');
        if (!searchInput) return;

        function getUrlParameter(name) {
            const regex = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)');
            const results = regex.exec(location.search);
            return results ? decodeURIComponent(results[1].replace(/\+/g, '%20')) : '';
        }

        function schoolSearch(query) {
            const schools = document.querySelectorAll('.school-list__school');
            const letters = document.querySelectorAll('.school-list__letter');
            const noHit = document.querySelector('.school-list__no-hit');

            // Show all schools and hide no-hit message
            schools.forEach(school => school.style.display = '');
            if (noHit) noHit.style.display = 'none';

            if (query === '') {
                letters.forEach(letter => letter.style.display = '');
                return;
            }

            // Hide all letters initially
            letters.forEach(letter => letter.style.display = 'none');

            // Filter schools
            const lowerQuery = query.toLowerCase();
            let visibleCount = 0;
            const visibleLetters = new Set();

            schools.forEach(school => {
                const schoolName = school.getAttribute('data-school') || '';
                if (schoolName.toLowerCase().includes(lowerQuery)) {
                    school.style.display = '';
                    visibleCount++;
                    
                    // Track which letters should be visible
                    const firstLetter = schoolName.substring(0, 1).toUpperCase();
                    visibleLetters.add(firstLetter);
                } else {
                    school.style.display = 'none';
                }
            });

            // Show relevant letter headers
            visibleLetters.forEach(letter => {
                const letterElement = document.querySelector(`.school-list__letter[data-letter="${letter}"]`);
                if (letterElement) letterElement.style.display = '';
            });

            // Show no-hit message if needed
            if (visibleCount === 0 && noHit) {
                noHit.style.display = '';
            }
        }

        // Handle input event
        searchInput.addEventListener('input', function() {
            schoolSearch(this.value);
        });

        // Initialize with URL parameter if present
        const query = getUrlParameter('q');
        if (query) {
            searchInput.value = query;
            schoolSearch(query);
        }
    }

    // School Calendar Day Modal
    function initSchoolCalendarModal() {
        const modal = document.getElementById('calendar-day-modal');
        if (!modal) return;

        const modalOverlay = modal.querySelector('.calendar-day-modal-overlay');
        const modalClose = modal.querySelector('.calendar-day-modal-close');
        const modalTitle = modal.querySelector('.calendar-day-modal-title');
        const modalBody = modal.querySelector('.calendar-day-modal-body');
        const calendarDays = document.querySelectorAll('.calendar-day[data-tooltip]');

        function openModal(dayElement) {
            const date = dayElement.getAttribute('data-date');
            const tooltip = dayElement.getAttribute('data-tooltip');
            const ariaLabel = dayElement.getAttribute('aria-label');

            if (!tooltip) return;

            // Parse date for title
            const dateObj = new Date(date + 'T00:00:00');
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            const formattedDate = dateObj.toLocaleDateString('no-NO', options);

            modalTitle.textContent = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
            modalBody.textContent = tooltip;

            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            
            // Focus on close button for accessibility
            setTimeout(() => modalClose.focus(), 100);
        }

        function closeModal() {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }

        // Add click event to all calendar days with comments
        calendarDays.forEach(day => {
            day.style.cursor = 'pointer';
            
            day.addEventListener('click', function(e) {
                e.preventDefault();
                this.blur(); // Fjern focus for å skjule tooltip
                openModal(this);
            });

            // Keyboard support - Enter or Space
            day.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.blur(); // Fjern focus for å skjule tooltip
                    openModal(this);
                }
            });
        });

        // Close modal on overlay click
        if (modalOverlay) {
            modalOverlay.addEventListener('click', closeModal);
        }

        // Close modal on close button click
        if (modalClose) {
            modalClose.addEventListener('click', closeModal);
        }

        // Close modal on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.style.display === 'flex') {
                closeModal();
            }
        });
    }

    // Toggle all details in list view
    function initListViewToggle() {
        const toggleBtn = document.querySelector('.calendar-toggle-all-btn');
        if (!toggleBtn) return;

        const container = document.querySelector('.calendar-months-container');
        if (!container) return;

        toggleBtn.addEventListener('click', function() {
            const action = this.getAttribute('data-action');
            const allDetails = container.querySelectorAll('.calendar-month-details');
            
            if (action === 'expand') {
                // Åpne alle
                allDetails.forEach(details => {
                    details.setAttribute('open', '');
                });
                this.setAttribute('data-action', 'collapse');
                this.textContent = this.textContent.replace(/Åpne alle|Expand all/i, 
                    document.documentElement.lang === 'en' ? 'Collapse all' : 'Lukk alle');
            } else {
                // Lukk alle
                allDetails.forEach(details => {
                    details.removeAttribute('open');
                });
                this.setAttribute('data-action', 'expand');
                this.textContent = this.textContent.replace(/Lukk alle|Collapse all/i, 
                    document.documentElement.lang === 'en' ? 'Expand all' : 'Åpne alle');
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initSchoolSearch();
            initSchoolCalendarModal();
            initListViewToggle();
        });
    } else {
        initSchoolSearch();
        initSchoolCalendarModal();
        initListViewToggle();
    }
})();

